// import 'assets/css/App.css';
import logo from "assets/img/company_logo_japanese_03.jpg";

function Header() {

  return (
    <div className="header-container">
        <img src={ logo } alt="三菱UFJ eスマート証券 logo" />
    </div>
  );
}

export default Header;
